import React from 'react';
import BannerCarouselBody from './BannerCarouselBody';
import BannersCol from './BannersCol';
import BannersMosaic from './BannersMosaic';
import Card from './Card';
import CarouselStories from './CarouselStories';
import Colapse from './Colapse';
import Description from './Description';
import Focus from './Focus';
import HighlightFilter from './HighlightFilter';
import InfiniteScroll from './InfiniteScroll';
import MediaYoutube from './MediaYoutube';
import PreferenceCards from './PreferenceCards';
// import MosaicBannerCarousel from './MosaicBannerCarousel';
// import MosaicBannerCarouselVertical from './MosaicBannerCarouselVertical';
import ProductCarouselQuery from './ProductCarouselQuery';
import ProductsCarrossel from './ProductsCarrossel';
import ProductTable from './ProductTable';
import PromotionalBannerCarouselBody from './PromotionalBannerCarouselBody';
import RedirectMenu from './RedirectMenu';
import RedirectTitle from './RedirectTitle';
import Topic from './Topic';
import UniqueBannerBody from './UniqueBannerBody';
import UniqueProduct from './UniqueProduct';
import VtexCollection from './VtexCollection';

const components: { [key: string]: React.FC } = {
  'banner-unico': UniqueBannerBody,
  'banner-unico-countdown': UniqueBannerBody,
  'banner-unico-com-contagem-regressiva': UniqueBannerBody,
  'banners-col': BannersCol,
  'banners-em-coluna': BannersCol,
  'banners-em-colunas': BannersCol,
  'banners-mosaic': BannersMosaic,
  'mosaico-de-banners': BannersMosaic,
  card: Card,
  'card-de-topicos': Card,
  'carrossel-de-banner': BannerCarouselBody,
  'cards-de-preferencias': PreferenceCards,
  // 'carrossel-de-banner-mosaico': MosaicBannerCarousel,
  // 'carrossel-de-banner-mosaico-vertical': MosaicBannerCarouselVertical,
  'carrossel-de-produtos': ProductsCarrossel,
  'carrossel-de-produtos-query': ProductCarouselQuery,
  'carrossel-de-produtos-com-query': ProductCarouselQuery,
  'carrossel-de-stories': CarouselStories,
  colapse: Colapse,
  colapsavel: Colapse,
  'colecao-vtex': VtexCollection,
  description: Description,
  'texto-de-descricao': Description,
  focus: Focus,
  'texto-de-foco': Focus,
  'highlight-filter': HighlightFilter,
  'filtro-destaque': HighlightFilter,
  'infinite-scroll': InfiniteScroll,
  'scroll-infinito': InfiniteScroll,
  'media-youtube': MediaYoutube,
  'promocional-carrossel-de-banner': PromotionalBannerCarouselBody,
  'carrosel-de-banner-promocional': PromotionalBannerCarouselBody,
  'redirect-menu': RedirectMenu,
  'links-redirecionaveis': RedirectMenu,
  'redirect-title': RedirectTitle,
  'titulo-com-redirecionamento': RedirectTitle,
  'table-products': ProductTable,
  'tabela-de-produtos': ProductTable,
  topic: Topic,
  topicos: Topic,
  'unique-product': UniqueProduct,
  'produto-unico': UniqueProduct,
};

export default components;
